import type { HeadlineStyleType, SubtitleStyle } from '@/features/headline-v1/headline-v1-type';

import React from 'react';

import logger from '@app/core-features/logger/logger';

import { useLayoutId } from '@/core/features/app/app-atoms';
import { useDeviceoutput } from '@/core/features/cookies/use-device-output';
import { headlineDesktopTitleVariants } from '@/features/headline-v1/headline-variants/headline-desktop-title-variants';
import { headlineSubtitleVariants } from '@/features/headline-v1/headline-variants/headline-subtitle-variants';
import { headlineTitleVariants } from '@/features/headline-v1/headline-variants/headline-title-variants';

export const useHeadlineVariants = (
    titleStyle: HeadlineStyleType,
    subtitleStyle: SubtitleStyle | null,
    htmlSubtitle: null | string,
) => {
    const { isDesktopView } = useDeviceoutput();
    const layoutId = useLayoutId();

    const titleVariant = React.useMemo(() => {
        const variant = isDesktopView
            ? headlineDesktopTitleVariants[titleStyle]
            : headlineTitleVariants(layoutId)[titleStyle];
        if (!variant) {
            logger.error(`Invalid titleStyle "${titleStyle}" in component HeadlineV1`);
        }
        return variant;
    }, [isDesktopView, layoutId, titleStyle]);

    const subtitleVariant = React.useMemo(() => {
        const variant = subtitleStyle && headlineSubtitleVariants[subtitleStyle];
        if (htmlSubtitle && !variant) {
            logger.error(`Invalid subtitleStyle "${subtitleStyle}" in component HeadlineV1`);
        }

        return variant;
    }, [htmlSubtitle, subtitleStyle]);

    return { subtitleVariant, titleVariant };
};
